import Marquee from "react-fast-marquee";

const items = [
  "FREDERICTON",
  "SAINT JOHN",
  "MONCTON",
  "DIEPPE",
  "MIRAMICHI",
  "EDMUNDSTON",
  "BATHURST",
  "SHEDIAC",
  "CARAQUET",
  "QUISPAMSIS",
  "ROTHESAY",
  "SUSSEX",
  "WOODSTOCK",
  "CAMPBELLTON",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="border-y border-border py-8 bg-[hsl(0_0%_5%)] overflow-hidden"
    >
      <Marquee gradient={false} speed={40} pauseOnHover={false}>
        {items.map((it, i) => (
          <span
            key={i}
            className="mx-8 font-serif italic font-light text-4xl md:text-6xl tracking-tight"
          >
            {it}
            <span className="mx-8 text-primary">✕</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
